import { t } from '@lingui/macro';

type ErrorType = {
  [key: number]: string;
};

export const ERROR_TYPE: ErrorType = {
  // 400: t`Bad Request`,
  409: t`Conflict`,
};
